import { Box, Paper, Typography, useTheme } from "@mui/material";
import HulpmiddelList from "../TaskOverview/HulpmiddelList";
import useResponsive from "../../hooks/useResponsive";

interface TaskEditHeaderProps {
  projectName: string;
  tool: any;
  setIsLoading: (loading: boolean) => void;
}

const TaskEditHeader: React.FC<TaskEditHeaderProps> = ({
  projectName,
  tool,
  setIsLoading,
}) => {
  const theme = useTheme();
  const { isDesktop } = useResponsive()
  return (
    <Paper
      elevation={3}
      sx={{
        bgcolor: theme.palette.blueColors.main,
        p: 2,
        width: isDesktop ? "90%" : "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            // alignItems: "center",
            alignItems: "flex-start", // Aligns to the top for consistent baseline
            gap: 1, // Adds spacing between the label and value
          }}
        >
          <Typography
            fontFamily={"Nunito Sans Regular700"}
            fontSize={"14px"}
            sx={{
              flex: "0 0 20%",
              pr: 1,
              color: "secondary.main",
              whiteSpace: "nowrap", // Prevents the label from breaking
            }}
          >
            Projectnaam
          </Typography>
          <Typography
            fontFamily={"Nunito Sans Regular700"}
            fontSize={"14px"}
            sx={{
              // flex: "0 0 80%",
              flex: "1", // Allows the value to take up remaining space
              wordBreak: "break-word",
              color: "secondary.main",
            }}
          >
            {projectName}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
          }}
        >
          <Typography
            fontFamily={"Nunito Sans Regular700"}
            fontSize={"14px"}
            sx={{
              flex: "0 0 20%",
              pr: 1,
              color: "secondary.main",
              whiteSpace: "nowrap",
            }}
          >
            Hulpmiddel
          </Typography>

          <Box
            sx={{
              // flex: "0 0 80%",
              flex: "1",
              wordBreak: "break-word",
            }}
          >
            <HulpmiddelList data={tool} loader={setIsLoading} />
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default TaskEditHeader;
